import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import {
  CareTypeDispatchTypes,
  DisciplinesDispatchTypes,
} from "../models/DispatchTypes/ServiceRequest";
import {
  CareTypeActionDispatchTypes,
  DisciplinesActionDispatchTypes,
} from "../constants/ServiceRequest";
import { GetCareType, GetDisciplines } from "../services/ServiceRequest";
import { configUrl } from "../constants/Config";
import { DisciplineSearch } from "../models/ServiceRequest";

export const getCareType: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    CareTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: CareTypeActionDispatchTypes.CARE_TYPE_INVOKE,
    });

    const response = await GetCareType(configUrl);

    dispatch({
      response,
      type: CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS,
    });
  };
};

export const getDisciplines: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplinesDispatchTypes
  >
> = (payload: DisciplineSearch) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplinesActionDispatchTypes.DISCIPLINES_INVOKE,
    });

    const response = await GetDisciplines(configUrl, payload);

    dispatch({
      response,
      type: DisciplinesActionDispatchTypes.DISCIPLINES_SUCCESS,
    });
  };
};